<div class="h-full sm:bg-white overflow-x-hidden" *ngIf="courseCatalogLandingPageOverview && !isLoading; else shimmer">
    <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="flex-start center" class="pt-sm-32 px-sm-32">
        <div class="module-image-wrapper relative mr-24 mb-12 mb-sm-0">
            <div
                class="image-container"
                fxLayout="row"
                fxLayoutAlign="space-between"
                #content
                [ngStyle]="
                    courseCatalogLandingPageOverview.landingPage.image && {
                        background: 'url(' + courseCatalogLandingPageOverview.landingPage.image.url + ') center / cover no-repeat '
                    }
                "
                [class.no-image]="!courseCatalogLandingPageOverview.landingPage.image"
            >
                <mat-icon class="bg-icon" svgIcon="bg_illustration" *ngIf="!courseCatalogLandingPageOverview.landingPage.image"></mat-icon>
            </div>

            <img
                style="display: none"
                *ngIf="courseCatalogLandingPageOverview.landingPage.image?.unsplash"
                [src]="unsplashViewsBaseUrl + courseCatalogLandingPageOverview.landingPage.image.unsplash.unsplashId"
            />
        </div>

        <h2 class="font-semibold text-3xl sm:text-4xl text-gray-700 my-0">{{ courseCatalogLandingPageOverview.landingPage.title }}</h2>
    </div>

    <div class="pt-12 pt-sm-24">
        <div class="px-sm-32" *ngIf="courseCatalogLandingPageOverview.landingPage.description">
            <div [innerHTML]="courseCatalogLandingPageOverview.landingPage.description | markdown"></div>
        </div>

        <div class="pb-168 w-full" *ngIf="courseCatalogLandingPageOverview.categorySections.length">
            <ng-container *ngFor="let categorySection of courseCatalogLandingPageOverview.categorySections">
                <div class="mb-24 mt-48 px-sm-32" fxLayout="row" fxLayoutAlign="space-between">
                    <h2 class="font-semibold my-0 text-lg">{{ categorySection.name }}</h2>
                    <app-white-button
                        *ngIf="categorySection.postingStream?.length"
                        [label]="'GENERAL.BUTTON.DISCOVER_MORE'"
                        (click)="navigateToCategory(categorySection.id)"
                        [disabled]="isInsideDialog"
                    ></app-white-button>
                </div>
                <ng-container *ngIf="categorySection.postingStream?.length; else noCategoryPostingsState">
                    <app-catalog-postings-swipper [isInsideDialog]="true" [featuredWidget]="categorySection.postingStream"></app-catalog-postings-swipper>
                </ng-container>
            </ng-container>
        </div>
        <ng-template #noCategoryPostingsState>
            <div class="px-sm-32">
                <div class="no-courses-empty-state__card" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
                    <mat-icon class="no-courses-empty-state__icon" svgIcon="no_courses"></mat-icon>
                    <div class="no-courses-empty-state__content">
                        <h3 class="no-courses-empty-state__title">{{ 'GENERAL.LABEL.NO_COURSES_AVAILABLE_HERE_YET' | translate }}</h3>
                        <p class="no-courses-empty-state__description">
                            {{ 'GENERAL.LABEL.NEW_CONTENT_WILL_BE_ADDED_SOON_STAY_TUNED' | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-template>

        <div
            class="catalog-postings-swipper-container relative pt-24 px-sm-32 pb-168"
            *ngIf="courseCatalogLandingPageOverview.landingPage.category.type === 'offerings'"
            fxLayout="row wrap"
            fxLayoutAlign="flex-start space-between"
        >
            <form [formGroup]="filterForm" class="w-100-p mb-12 filters-container" *ngIf="filterValues.length && filterForm && hasUnfilteredPostings">
                <!-- LANGUAGE FILTER -->
                <mat-form-field appearance="outline" class="responsive-filter-field">
                    <mat-label>{{ 'GENERAL.PROPERTY.LANGUAGE' | translate }}</mat-label>
                    <mat-select formControlName="language">
                        <mat-option *ngIf="hasSelection('language')" [value]="null">{{ 'GENERAL.PROPERTY.CLEAR_SELECTION' | translate }}</mat-option>
                        <mat-option *ngFor="let lang of languageService.languages | filterLanguages" [value]="lang.id">
                            <span fxLayout="row" fxLayoutAlign="start center">
                                <img alt="" class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.svg'" />
                                <span class="iso" [translate]="lang.translate">{{ lang.title }}</span>
                            </span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- POSTING TYPE FILTER -->
                <mat-form-field appearance="outline" class="responsive-filter-field">
                    <mat-label>{{ 'ENGAGE.POSTING.TYPE' | translate }}</mat-label>
                    <mat-select formControlName="postingType">
                        <mat-option *ngIf="hasSelection('postingType')" [value]="null">{{ 'GENERAL.PROPERTY.CLEAR_SELECTION' | translate }}</mat-option>
                        <mat-option *ngFor="let type of postingTypes" [value]="type.id">
                            {{ type.displayNameKeySingular | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <ng-container *ngFor="let filter of filterValues">
                    <!-- VALUE LIST -->
                    <mat-form-field *ngIf="filter.type === 'value_list'" appearance="outline" class="responsive-filter-field">
                        <mat-label>{{ filter.translationKey | translate }}</mat-label>
                        <mat-select [formControlName]="filter.name">
                            <mat-option *ngIf="hasSelection(filter.name)" [value]="null">{{ 'GENERAL.PROPERTY.CLEAR_SELECTION' | translate }}</mat-option>
                            <mat-option *ngFor="let val of filter.values" [value]="val.value">
                                {{ val.translationKey ? (val.translationKey | translate) : val.value }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- NUMBER RANGE -->
                    <div *ngIf="filter.type === 'number_range'" class="responsive-filter-field number-range-field">
                        <div class="number-range-field-control">
                            <span class="number-range-field-label">{{ filter.translationKey | translate }}</span>
                            <div class="range-input-align-center" fxLayout="row" fxLayoutAlign="start center">
                                <input
                                    class="range-start-input"
                                    type="number"
                                    [formControlName]="filter.name + '_min'"
                                    [placeholder]="filter.min ? ('GENERAL.LABEL.MIN_FORMAT' | translate: { number: filter.min }) : ('GENERAL.LABEL.MIN' | translate)"
                                    [attr.min]="filter.min"
                                    [attr.max]="filter.max"
                                />
                                <span class="range-separator">–</span>
                                <input
                                    class="range-end-input"
                                    type="number"
                                    [formControlName]="filter.name + '_max'"
                                    [placeholder]="filter.max ? ('GENERAL.LABEL.MAX_FORMAT' | translate: { number: filter.max }) : ('GENERAL.LABEL.MAX' | translate)"
                                    [attr.min]="filter.min"
                                    [attr.max]="filter.max"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- DATE RANGE -->
                    <mat-form-field *ngIf="filter.type === 'date_range'" appearance="outline" class="responsive-filter-field range-single-field">
                        <mat-label>{{ 'GENERAL.PROPERTY.DATE_RANGE' | translate }}</mat-label>
                        <mat-date-range-input
                            [rangePicker]="picker"
                            [formGroup]="filterForm"
                            [min]="dateRangeLimits[filter.name]?.min"
                            [max]="dateRangeLimits[filter.name]?.max"
                            class="range-input-align-center"
                        >
                            <input
                                matStartDate
                                [formControlName]="filter.name + '_min'"
                                [placeholder]="'GENERAL.LABEL.MIN' | translate"
                                autocomplete="off"
                                readonly
                                inputmode="none"
                                (click)="picker.open()"
                                (focus)="picker.open()"
                            />
                            <input
                                matEndDate
                                [formControlName]="filter.name + '_max'"
                                [placeholder]="'GENERAL.LABEL.MAX' | translate"
                                autocomplete="off"
                                readonly
                                inputmode="none"
                                (click)="picker.open()"
                                (focus)="picker.open()"
                            />
                        </mat-date-range-input>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </ng-container>
            </form>

            <!-- POSTINGS -->
            <div class="catalog-postings-swipper w-full pb-168 pt-24" fxLayout="row wrap" fxLayoutGap="8px" *ngIf="postings.length; else noSearchResults">
                <div
                    *ngFor="let postingResource of postings; index as index; first as isFirst; last as isLast"
                    class="mb-8 relative user-details-card-container pointer"
                    fxLayout="row wrap"
                    fxLayoutAlign="center center"
                    fxFlex="1 0 calc(100% - 8px)"
                    fxFlex.gt-xs="1 0 calc(50% - 8px)"
                    fxFlex.gt-sm="1 0 calc(33.33% - 8px)"
                >
                    <app-course-catalog-posting-card
                        class="w-full"
                        [postingResource]="postingResource"
                        [index]="index"
                        [isLast]="isLast"
                        [isFirst]="isFirst"
                        [hoverPosition]="getPostingHoverPosition(index)"
                    ></app-course-catalog-posting-card>
                </div>
            </div>

            <ng-template #noSearchResults>
                <ng-container *ngIf="showNoResultsFoundState; else noCoursesState">
                    <div fxLayout="column" fxLayoutAlign="center center" class="no-search-results-container mt-48 w-full">
                        <mat-icon class="participant-view-illustration" svgIcon="search_no_results"></mat-icon>
                        <h2 class="mt-8 mb-12">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                        <span>
                            {{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}
                        </span>
                    </div>
                </ng-container>
                <ng-template #noCoursesState>
                    <div class="no-courses-empty-state w-full">
                        <div class="no-courses-empty-state__card" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
                            <mat-icon class="no-courses-empty-state__icon" svgIcon="no_courses"></mat-icon>
                            <div class="no-courses-empty-state__content">
                                <h3 class="no-courses-empty-state__title">{{ 'GENERAL.LABEL.NO_COURSES_AVAILABLE_HERE_YET' | translate }}</h3>
                                <p class="no-courses-empty-state__description">
                                    {{ 'GENERAL.LABEL.NEW_CONTENT_WILL_BE_ADDED_SOON_STAY_TUNED' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </div>

        <div class="px-sm-32 mt-48 pb-168" *ngIf="showCategoryLevelEmptyState">
            <div class="no-courses-empty-state__card" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
                <mat-icon class="no-courses-empty-state__icon" svgIcon="no_courses"></mat-icon>
                <div class="no-courses-empty-state__content">
                    <h3 class="no-courses-empty-state__title">{{ 'GENERAL.LABEL.NO_COURSES_AVAILABLE_HERE_YET' | translate }}</h3>
                    <p class="no-courses-empty-state__description">
                        {{ 'GENERAL.LABEL.NEW_CONTENT_WILL_BE_ADDED_SOON_STAY_TUNED' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #shimmer>
    <div class="shimmer-container min-w-full sm:bg-white pt-sm-32 px-sm-32 pb-168">
        <div class="shimmer">
            <div class="shimmer-card table animate h-332 mb-24"></div>
            <div class="shimmer-card table animate h-148"></div>
        </div>
    </div>
</ng-template>
